

<div id="InsightsSlider" class="container-fluid carousel slide d-none d-lg-block">
    <div class=" row carousel-inner">
       <div *ngFor="let slide of sliderData; let i = index" class="  carousel-item" [ngClass]="{ 'active': i === currentIndex }">
        <div class="row">
       <div id="slider_{{slide.id}}" class="col-lg-6 col-md-6 col-sm-12 order-1 InsightPaddingTop">
          <div class="row">
             <div class="col-12">
                <div class="insight-content global_section_header pl_10_percent insight-content">
                   <div [innerHTML]="slide.headerText"></div>
                </div>
                <div class="pl_10_percent insight-subcontent pt-lg-3">
                   <div class="insight-subcontent global_section_content px-0 pt-lg-5" [innerHTML]="slide.bodyText"></div>
                   <div [innerHTML]="slide.readMore"></div>
                </div>
                <div class="pl_10_percent global_mainbutton insight-button text-left col pt-5 ">
                   <a href="/postpandamic" class="btn btn-lg d-inline-flex justify-content-between align-items-center global_button">
                      <div class="dub-arrow"><img src="../../../assets/images/aiimages/arrowBlack.png" alt="insightbutton" /></div>
                      READ INSIGHTS
                   </a>
                </div>
             </div>
          </div>
       </div>
       <div class="col-lg-6 col-md-6 col-sm-12 order-2 pt-12Dot5_percent ">
          <div class="insightimage-carousel h-100">
             <div class="d-flex align-items-center h-100">
                <button class="btn btn-previous btn-outline-primary " id="insights_prev" aria-label="Previous" (click)="onPreviousClick()">
                <i class="fa-solid fa-chevron-left text-white"></i>
                </button>
                <div class="d-flex w-100 h-100">
                   <div class="insights_active p-4" [innerHTML]="slide.img"></div>
                </div>
                <button class="btn btn-next" id="insights_next" aria-label="Next" (click)="onNextClick()">
                <i class="fa-solid fa-chevron-right"></i>
                </button>
             </div>
          </div>
       </div>
      </div>
    </div>
  </div>
  </div>
  